<div class="header">
    <div class="logo">
        <a href="/">
            <img src="https://dev-products.twikit.com/assets/images/twikit/logo.svg" />
        </a>
        <div class="title">x</div>
        <a href="/">
            <img src="assets/images/logo.jpg" />
        </a>
        <mat-divider [vertical]="true"></mat-divider>
    </div>
    <div class="title">{{title}}</div>
</div>
<router-outlet>
</router-outlet>